import React from 'react';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import BaseIconButton, { IBaseIconButtonProps } from './_module/BaseIconButton';

interface IProps extends IBaseIconButtonProps {
  iconFontSize?: SvgIconTypeMap['props']['fontSize'];
  copyText?: string;
  iconHtmlFontSize?: string;
}

export default function CopyIconButton(props: IProps) {
  const {
    onClick,
    size,
    iconFontSize,
    tooltip,
    copyText,
    iconHtmlFontSize,
  } = props;

  function copyToClipboard() {
    if (copyText) {
      navigator.clipboard.writeText(copyText);
      // const input = document.createElement('textarea');
      //
      // input.innerHTML = copyText;
      // document.body.appendChild(input);
      // input.select();
      // document.execCommand('copy');
      //
      // document.body.removeChild(input);
    }
  }

  return (
    <BaseIconButton
      onClick={onClick || copyToClipboard}
      tooltip={tooltip}
      size={size || 'small'}
    >
      <FileCopyIcon
        style={{ fontSize: iconHtmlFontSize }}
        fontSize={iconFontSize || 'small'}
      />
    </BaseIconButton>
  );
}
